export function propertiesNotNullish<T, TKey extends keyof T>(
  input: T,
  ...keys: TKey[]
): input is T & { [_ in TKey]: NonNullable<T[TKey]> } {
  return keys.every(key => input[key] !== null && input[key] !== undefined);
}
